import { concatStyleSets, ITheme } from '@fluentui/react/lib/Styling';
import { memoizeFunction } from '@fluentui/react/lib/Utilities';

import {
  AppColors,
  commonHighContrastHoverFocusStyles,
  commonHighContrastOutlineFocusedDisabled,
  commonHighContrastOutlineHoverFocus,
  controlPalette,
  getStandardControlSemanticColorsWithTheme,
  StandardControlSemanticColors,
} from '@1js/acui-common';
import { isThemingEnabled } from '@1js/acui-theme';

import { InsertTableStyles } from './RibbonInsertTable.Props';

export const getInsertTableStyles = memoizeFunction(
  (theme: ITheme, appColors: AppColors, customStyles?: Partial<InsertTableStyles>): Partial<InsertTableStyles> => {
    const semanticColors: StandardControlSemanticColors = getStandardControlSemanticColorsWithTheme(theme);
    const themingEnabled = isThemingEnabled();
    const cellHighlightStyles = [
      {
        backgroundColor: themingEnabled ? semanticColors.cellHighlightBackgroundColor : '#DADADA',
        border: `1px solid ${semanticColors.cellHighlightBorderColor}`,
        zIndex: 2,
      },
      commonHighContrastOutlineHoverFocus,
      commonHighContrastHoverFocusStyles,
    ];
    const insertTableStyles: Partial<InsertTableStyles> = {
      root: {
        display: 'block',
        border: '1px solid transparent',
        padding: 10,
        selectors: {
          table: {
            borderSpacing: '0',
          },
          'table tr td:not(:first-child) div': {
            marginLeft: -1,
          },
          'table tr:not(:first-child) td div': {
            marginTop: -1,
          },
          ':focus': {
            outline: 0,
          },
        },
      },
      cell: {
        border: `1px solid ${semanticColors.selectedBorderColor}`,
        width: 15,
        height: 15,
        position: 'relative',
        selectors: {
          ':focus': cellHighlightStyles,
        },
      },
      cellHighlighted: cellHighlightStyles,
      cellDisabled: [
        {
          backgroundColor: themingEnabled ? theme.palette.themeDarkAlt : appColors.shade10,
          selectors: {
            ':focus': commonHighContrastOutlineFocusedDisabled,
          },
        },
      ],
      tableTitle: {
        height: 32,
        fontSize: 14,
        lineHeight: 32,
        color: themingEnabled ? semanticColors.menuItemTextColor : controlPalette.menuItemTextColor,
        background: semanticColors.menuBackgroundColor,
        fontWeight: '600',
      },
      tableTitleInnerSpan: {
        marginLeft: 12,
        verticalAlign: 'middle',
      },
    };

    return concatStyleSets(insertTableStyles, customStyles);
  }
);

export const insertTableMLRStyles: Partial<InsertTableStyles> = {
  root: {
    paddingTop: 0,
    border: 'none',
  },
  tableTitle: {
    height: 28,
    lineHeight: 28,
    fontSize: 12,
  },
};
